<!-- static content data from lang: login -->
<template>
  <div class="h-100">
<div class="py-3 h-100" v-loading="loading">
    <div class="container pb-5 h-100">
      <div class="row justify-content-center align-items-center h-100">

        <div class="col-lg-5 col-md-7">
          <div class="brand-logo">
<!--          <img src="img/brand/logo.jpg">-->
          <div style="color:white; font-size: 40px;">Smart Visitor</div>
        </div>
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h3>{{lang.label.heading}}</h3>
              </div>

  <!-- <Alert :alert-message="invalidCredentials" :variant="variant" :show-alert="showAlert" v-if="showAlert" @removeAlertModal="removeAlertModal"></Alert> -->
              <template v-for="(message) in alertMessages">
                <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <template v-for="(message) in successMessages">
                <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <div class="form-group">
                    <base-input
                      :label="lang.label.loginAs"
                      labelClasses="form-control-label asterisk-mark"
                      name="communication type"
                      :rules="{required: true}"
                    >
                      <b-form-group class="mb-0">
                        <b-form-radio-group
                          id="radio-group"
                          v-model="model.userType"
                          @change="userChange"
                          autocomplete="off"
                          :options="userType"
                          name="radio-options"
                        ></b-form-radio-group>
                      </b-form-group>
                    </base-input>
                  </div>
                  <template v-if="model.userType == 'second'">
                    <base-input alternative
                                class="mb-3"
                                name="username"
                                rules="required"
                                prepend-icon="ni ni-single-02"
                                :placeholder="lang.label.userName + '*'"
                                v-model="model.userName"
                                autocomplete="off">
                    </base-input>
                    <base-input alternative
                                class="mb-3"
                                name="password"
                                rules="required"
                                prepend-icon="ni ni-lock-circle-open"
                                group
                    >
                      <input :type="passwordFieldType" :placeholder="lang.label.password + '*'" v-model="model.password" class="form-control" aria-label="password" autocomplete="off">
                      <div class="icon-pos" @click="switchVisibility" v-if="model.password!=''">
                      <i class="fa fa-eye" v-if="passwordFieldType=='password'"></i>
                      <i class="fa fa-eye-slash" v-else aria-hidden="true"></i>
                    </div>
                    </base-input>
                  </template>
                  <template v-else>
                    <base-input alternative
                                class="mb-3"
                                name="ID/Passport"
                                rules="required"
                                prepend-icon="ni ni-single-02"
                                :placeholder="lang.label.passport + '*'"
                                v-model="model.userName"
                                autocomplete="off">
                    </base-input>
                  </template>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">{{lang.label.buttons.logIn}}</base-button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 text-center">
              <span><small>{{lang.label.noAccount}} <router-link to="/sign-up" class="text-light">{{lang.label.signUp}}</router-link></small></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
 import {mapGetters} from "vuex";
 import Alert from "@/components/BaseAlert.vue";
 import {prevType} from "../../store/getters";
  export default {
    data() {
      return {
        data:[],
        userType: [
              { text: "Visitor", value: "first"},
              { text: "System User", value: "second" },
        ],
        passwordFieldType: "password",
        lang: this.$lang.login,
        errored:false,
        alertType: 'danger',
        successType: 'success',
        alertMessages: [],
        successMessages: [],
        loading: false,
        model: {
          userName: '',
          password: '',
          rememberMe: false,
          userType: '',
        }
      };
    },
    components:{
      Alert,
    },
      computed: {
    ...mapGetters({
        login: "login",
        sessionExpired: "sessionExpired",
        prevType: "prevType",
        unauthorized:"unauthorized",
        disqualified:"disqualified",
    }),
  },
  created(){
      this.$store.commit('setType',null);
      localStorage.removeItem('type');
  },
  mounted(){
      this.$store.commit('setAlertMessage', '');
      this.$store.commit('setSuccessMessage', '');
      let self = this;
      if(this.disqualified){
          this.successMessages.push(this.disqualified);
          this.$store.commit('setDisqualified', '');
          let timer = setTimeout(function () {
              if(self.loading == false){
                  self.successMessages = [];
                  self.alertMessages = [];
                  clearTimeout(timer)
              }
          },5000)
      }
      this.model.userType = 'first';
  },
  methods: {
      userChange(){
          this.model.userName = '';
          this.model.password = '';
          this.$refs.formValidator.reset();
      },
      removeMessage(){
          let self = this;
              let timer = setTimeout(function () {
                  if(self.loading == false){
                      self.alertMessages = [];
                      clearTimeout(timer)
                  }
              },3000)
      },
      switchVisibility(){
          this.passwordFieldType =
              this.passwordFieldType === "password" ? "text" : "password";
      },
      onSubmit() {
          let self = this;
        this.loading = true;
        let data = {
                "username":this.model.userName,
            };
        if(this.model.password && this.model.userType == 'second'){
            data.password = this.model.password
        }
              this.$store.dispatch('login', data)
                    .then(response => {
                      if(response.status == 200){
                          this.$store.commit("setLogin", response.data);
                          let type = null;
                         if(response.data.IsCompanyAdmin){
                             type = 2;
                         }else if(response.data.IsVisitor){
                             type = 3;
                         }else if(response.data.IsAdministrator){
                             type = 1;
                         }else if(response.data.IsSiteAdmin){
                             type = 4;
                         }else if(response.data.IsRegistrar){
                             type = 5;
                         }else if(response.data.IsApproverReporter){
                             type = 6;
                         }
                          /*else {
                              type = 5;
                         }*/
                          if(type) {
                              this.$store.commit('setType',type);
                              this.alertMessage = "Successfully Logged in";
                              this.type = "primary";
                          }
                          let prevRoute = localStorage.getItem('LS_ROUTE_KEY');
                          this.loading = false;
                          if((prevRoute && type == 3 && prevRoute.includes('visitor-form'))){
                              this.$router.push({path: prevRoute});
                          }else{
                              this.$store.commit('setPrevType',null);
                              localStorage.removeItem('prevType');
                              localStorage.removeItem('LS_ROUTE_KEY');
                              if(type == 1){ // admin
                                  this.$router.push({name: "companyManagementList"});
                              }else if(type == 2){ // company
                                  this.$router.push({name: "visitorRequestApproval"});
                              }else if(type == 3){ // visitor
                                  this.$router.push({name: "visitorEditProfile"});
                              }else if(type == 4){ // site admin
                                  this.$router.push({name: "visitorRequestApproval"});
                              }else if(type == 5){ // registrar
                                  this.$router.push({name: "visitorManagement"});
                              }else if(type == 6){ // ApproverReporter
                                  this.$router.push({name: "visitorRequestApproval"});
                              }
                          }
                      }else{
                        this.alertMessages.push(response.data.message);
                        setInterval(function () {
                              self.alertMessages = [];
                        },5000);
                        this.loading = false;
                      }
                    })
      }
    }
  };
</script>
